export const INVENTORY_SOURCE_URL =
  "https://pathfinder.d20srd.org/coreRulebook/equipment.html";

const PATHFINDER_FAMILY_URL = "https://pathfinder.family";
const ARCHIVES_OF_NETHYS_URL = "https://www.aonprd.com";

const ENGLISH_ITEM_NAME_OVERRIDES = {
  backpack: "Backpack (common)",
};

const FAMILY_ALIAS_OVERRIDES = {
  "punching-dagger": "daggerPunching",
  "spiked-gauntlet": "gauntletSpiked",
  "light-mace": "maceLight",
  "heavy-mace": "maceHeavy",
  "heavy-crossbow": "crossbowHeavy",
  "light-crossbow": "crossbowLight",
  "throwing-axe": "axeThrowing",
  "light-hammer": "hammerLight",
  "light-pick": "pickLight",
  "light-shield-weapon": "shieldLight",
  "spiked-armor": "spikedArmor",
  "light-spiked-shield": "spikedShieldLight",
  "short-sword": "swordShort",
  "heavy-pick": "pickHeavy",
  "heavy-shield-weapon": "shieldHeavy",
  "heavy-spiked-shield": "spikedShieldHeavy",
  "heavy-flail": "flailHeavy",
  "composite-longbow": "longbowComposite",
  "composite-shortbow": "shortbowComposite",
  "bastard-sword": "swordBastard",
  "dwarven-waraxe": "waraxeDwarven",
  "orc-double-axe": "axeOrcDouble",
  "spiked-chain": "chainSpiked",
  "elven-curve-blade": "curveBladeElven",
  "dire-flail": "flailDire",
  "gnome-hooked-hammer": "hammerGnomeHooked",
  "two-bladed-sword": "swordTwoBladed",
  "dwarven-urgrosh": "urgroshDwarven",
  "hand-crossbow": "crossbowHand",
  "repeating-heavy-crossbow": "crossbowRepeatingHeavy",
  "repeating-light-crossbow": "crossbowRepeatingLight",
  shuriken: "shuriken5",
  "halfling-sling-staff": "slingStaffHalfling",
  "blowgun-darts-10": "dartsBlowgun10",
  "crossbow-bolts-10": "boltsCrossbow10",
  "repeating-crossbow-bolts-5": "boltsCrossbowRepeating5",
  "sling-bullets-10": "bulletsSling10",
  "padded-armor": "padded",
  "leather-armor": "leather",
  "studded-leather": "studdedLeather",
  "chain-shirt": "chainShirt",
  "hide-armor": "hide",
  "scale-mail": "scaleMail",
  "splint-mail": "splintMail",
  "banded-mail": "bandedMail",
  "half-plate": "halfPlate",
  "full-plate": "fullPlate",
  "light-wooden-shield": "lightWoodenShield",
  "light-steel-shield": "lightSteelShield",
  "heavy-wooden-shield": "heavyWoodenShield",
  "heavy-steel-shield": "heavySteelShield",
  "tower-shield": "towerShield",
  "winter-blanket": "blanket",
  "block-and-tackle": "blockAndTackle",
  "glass-bottle": "bottle",
  "map-case": "scrollCase",
  "chain-10-ft": "chain",
  "fishing-net": "fishingNet",
  "flint-and-steel": "flintAndSteel",
  "grappling-hook": "grapplingHook",
  "clay-jug": "jug",
  "common-lamp": "lamp",
  "bullseye-lantern": "bullseyeLantern",
  "hooded-lantern": "hoodedLantern",
  "simple-lock": "lockSimple",
  "average-lock": "lockAverage",
  "good-lock": "lockGood",
  "superior-lock": "lockSuperior",
  "small-steel-mirror": "mirror",
  "clay-mug": "mugTankard",
  "lamp-oil": "oil",
  "miners-pick": "minerPick",
  "clay-pitcher": "pitcher",
  "ten-foot-pole": "pole",
  "iron-pot": "pot",
  "belt-pouch": "beltPouch",
  "portable-ram": "portableRam",
  "hemp-rope": "ropeHemp",
  "silk-rope": "silkRope",
  "sealing-wax": "sealingWax",
  "sewing-needle": "sewingNeedle",
  "signal-whistle": "signalWhistle",
  "signet-ring": "signetRing",
  "water-clock": "waterСlock",
  "alchemists-lab": "alchemistLab",
  "artisans-tools": "artisanTools",
  "climbers-kit": "cimberKit",
  "healers-kit": "healerKit",
  "holly-and-mistletoe": "hollyAndMistletoe",
  "wooden-holy-symbol": "holySymbolWooden",
  "silver-holy-symbol": "holySymbolSilver",
  "magnifying-glass": "magnifyingGlass",
  "common-instrument": "musicalInstrument",
  "merchants-scale": "merchantScale",
  "spell-component-pouch": "spellComponentPouch",
  "blank-spellbook": "spellbook",
  "thieves-tools": "thieveTools",
  "artisans-outfit": "artisanOutfit",
  "clerics-vestments": "clericVestments",
  "cold-weather-outfit": "coldWeatherOutfit",
  "courtiers-outfit": "courtierOutfit",
  "entertainers-outfit": "entertainerOutfit",
  "explorers-outfit": "explorerOutfit",
  "monks-outfit": "monkOutfit",
  "nobles-outfit": "nobleOutfit",
  "peasants-outfit": "peasantOutfit",
  "royal-outfit": "royalOutfit",
  "scholars-outfit": "scholarOutfit",
  "travelers-outfit": "travelerOutfit",
  "trail-rations": "trailRations",
  "ale-gallon": "aleGallon",
  "ale-mug": "aleMug",
  "common-wine": "wineCommonPitcher",
  "fine-wine": "wineFineBottle",
  "alchemists-fire": "alchemistFire",
};

const FAMILY_WEAPON_ALCHEMICAL_IDS = new Set([
  "acid",
  "alchemists-fire",
  "holy-water",
  "tanglefoot-bag",
  "thunderstone",
]);

const FAMILY_LETTER_OVERRIDES = {
  gauntlet: "Л", dagger: "К", "punching-dagger": "Т", "spiked-gauntlet": "Ш",
  "light-mace": "Л", sickle: "С", club: "Д", "heavy-mace": "Т",
  morningstar: "М", shortspear: "К", longspear: "Д", quarterstaff: "Б",
  spear: "К", blowgun: "Д", "heavy-crossbow": "Т", "light-crossbow": "Л",
  dart: "Д", sling: "П", "throwing-axe": "М", "light-hammer": "Л",
  handaxe: "Т", kukri: "К", "light-pick": "Л", sap: "М",
  "light-shield-weapon": "Л", "spiked-armor": "Ш", "light-spiked-shield": "Ш",
  starknife: "Н", "short-sword": "К", battleaxe: "Б", flail: "Ц",
  longsword: "Д", "heavy-pick": "Т", scimitar: "С", "heavy-shield-weapon": "Т",
  "heavy-spiked-shield": "Ш", trident: "Т", warhammer: "Б", falchion: "Ф",
  glaive: "Г", greataxe: "Д", greatclub: "Д", "heavy-flail": "Т",
  greatsword: "Д", guisarme: "Г", halberd: "А", lance: "К", scythe: "К",
  longbow: "Д", "composite-longbow": "К", shortbow: "К",
  "composite-shortbow": "К", kama: "К", nunchaku: "Н", sai: "С", siangham: "С",
  "bastard-sword": "М", "dwarven-waraxe": "Д", whip: "К", "orc-double-axe": "Д",
  "spiked-chain": "Ш", "elven-curve-blade": "Э", "dire-flail": "Д",
  "gnome-hooked-hammer": "Г", "two-bladed-sword": "Д", "dwarven-urgrosh": "Д",
  bolas: "Б", "repeating-heavy-crossbow": "М", "repeating-light-crossbow": "М",
  net: "С", shuriken: "С", "halfling-sling-staff": "П",
  "padded-armor": "С", "leather-armor": "К", "studded-leather": "К",
  "chain-shirt": "К", "hide-armor": "С", "scale-mail": "Ч", chainmail: "К",
  breastplate: "Н", "splint-mail": "П", "banded-mail": "Л", "half-plate": "К",
  "full-plate": "П", buckler: "Б", "light-wooden-shield": "Л",
  "light-steel-shield": "Л", "heavy-wooden-shield": "Т",
  "heavy-steel-shield": "Т", "tower-shield": "Б", barrel: "Б", basket: "К",
  bedroll: "С", bell: "К", "winter-blanket": "О", "block-and-tackle": "П",
  "glass-bottle": "Б", bucket: "В", caltrops: "Ч", candle: "С", canvas: "Х",
  "map-case": "Т", "chain-10-ft": "Ц", chalk: "М", chest: "С", crowbar: "Л",
  firewood: "Д", flask: "С", "flint-and-steel": "О", "grappling-hook": "К",
  hammer: "М", hourglass: "П", ink: "Ч", inkpen: "П", "clay-jug": "Г",
  ladder: "Л", "common-lamp": "Л", "bullseye-lantern": "Ф",
  "hooded-lantern": "Ф", "simple-lock": "З", "average-lock": "З",
  "good-lock": "З", "superior-lock": "З", manacles: "К",
  "small-steel-mirror": "З", "clay-mug": "К", "lamp-oil": "М", paper: "Б",
  parchment: "П", "miners-pick": "Ш", "clay-pitcher": "К", piton: "К",
  "ten-foot-pole": "Ш", "iron-pot": "К", "belt-pouch": "П", "hemp-rope": "В",
  "silk-rope": "В", sack: "М", "sealing-wax": "С", "sewing-needle": "Ш",
  shovel: "Л", "signal-whistle": "С", "signet-ring": "П", sledge: "К",
  spyglass: "П", tent: "П", torch: "Ф", vial: "П", "water-clock": "В",
  waterskin: "Б", whetstone: "Т", "alchemists-lab": "А",
  "artisans-tools": "И", "climbers-kit": "Н", "healers-kit": "Н",
  "holly-and-mistletoe": "П", "wooden-holy-symbol": "С",
  "silver-holy-symbol": "С", "magnifying-glass": "У", "common-instrument": "М",
  "merchants-scale": "Т", "spell-component-pouch": "С", "blank-spellbook": "К",
  "thieves-tools": "Н", "artisans-outfit": "О", "clerics-vestments": "О",
  "cold-weather-outfit": "Т", "courtiers-outfit": "П",
  "entertainers-outfit": "С", "explorers-outfit": "О", "monks-outfit": "М",
  "nobles-outfit": "Д", "peasants-outfit": "К", "royal-outfit": "К",
  "scholars-outfit": "О", "travelers-outfit": "О", "trail-rations": "С",
  "ale-gallon": "Э", "ale-mug": "Э", bread: "Х", cheese: "С", meat: "М",
  antitoxin: "П", smokestick: "Д", sunrod: "С", tindertwig: "С",
};

const toCamelCase = (value) =>
  value.replace(/-([a-z0-9])/g, (_, character) => character.toUpperCase());

const getPathfinderFamilyLocation = (item) => {
  if (item.category === "weapon") {
    return { route: "weapons" };
  }
  if (item.category === "ammunition") {
    return { route: "weapons" };
  }
  if (item.category === "armor") {
    return { route: "armors" };
  }
  if (FAMILY_WEAPON_ALCHEMICAL_IDS.has(item.id)) {
    return { route: "weapons" };
  }
  return { route: "goodsAndServices" };
};

const getPathfinderFamilyUrl = (item) => {
  const { route } = getPathfinderFamilyLocation(item);
  const alias = FAMILY_ALIAS_OVERRIDES[item.id] || toCamelCase(item.id);
  const letter = FAMILY_LETTER_OVERRIDES[item.id] || item.name.ru[0].toUpperCase();
  return `${PATHFINDER_FAMILY_URL}/${route}?menu=alphabet_${encodeURIComponent(letter)}&scroll=${encodeURIComponent(alias)}`;
};

const getEnglishReferenceUrl = (item) => {
  const page = item.category === "weapon" || item.category === "ammunition"
    ? "EquipmentWeaponsDisplay.aspx"
    : item.category === "armor"
      ? "EquipmentArmorDisplay.aspx"
      : "EquipmentMiscDisplay.aspx";
  const itemName = ENGLISH_ITEM_NAME_OVERRIDES[item.id] || item.name.en;
  return `${ARCHIVES_OF_NETHYS_URL}/${page}?ItemName=${encodeURIComponent(itemName)}`;
};

const poundsToKilograms = (pounds, precision = 2) =>
  pounds == null ? 0 : Number((pounds * 0.453592).toFixed(precision));

const parseDamageType = (value = "") => {
  const normalized = value.toLowerCase();
  if (normalized.includes("b")) return "bludgeoning";
  if (normalized.includes("p")) return "piercing";
  if (normalized.includes("s")) return "slashing";
  return "";
};

const calculateCriticalDamage = (damage = "", critical = "") => {
  const damageMatch = damage.match(/^(\d+)d(\d+)$/i);
  const multiplierMatch = critical.match(/×(\d+)$/);
  if (!damageMatch || !multiplierMatch) return "";
  return `${Number(damageMatch[1]) * Number(multiplierMatch[1])}d${damageMatch[2]}`;
};

const baseItem = (id, en, ru, category, priceGp, weightLb, extra = {}) => ({
  id,
  name: { en, ru },
  category,
  priceGp,
  weightLb,
  source: "Pathfinder First Edition Core Rulebook",
  sourceUrl: INVENTORY_SOURCE_URL,
  ...extra,
});

const weapon = (
  id, en, ru, proficiency, weaponType, priceGp, damage, critical,
  rangeFt, weightLb, damageCode, special = ""
) => baseItem(id, en, ru, "weapon", priceGp, weightLb, {
  type: "weapon",
  proficiency,
  weaponType,
  damage,
  critical,
  rangeFt,
  damageCode,
  damageType: parseDamageType(damageCode),
  special,
});

const ammunition = (id, en, ru, priceGp, weightLb, packSize) =>
  baseItem(id, en, ru, "ammunition", priceGp, weightLb, {
    type: "ammunition",
    packSize,
  });

const armor = (id, en, ru, armorCategory, priceGp, weightLb, armorClass) =>
  baseItem(id, en, ru, "armor", priceGp, weightLb, {
    type: "armor",
    armorCategory,
    armorType: armorCategory === "shield" ? "shield" : "armor",
    armorClass,
  });

const gear = (id, en, ru, category, priceGp, weightLb) =>
  baseItem(id, en, ru, category, priceGp, weightLb, {
    type: category === "food" || category === "alchemical" ? "consumable" : "gear",
  });

const WEAPONS = [
  weapon("gauntlet", "Gauntlet", "Латная перчатка", "simple", "melee", 2, "1d3", "×2", null, 1, "B"),
  weapon("dagger", "Dagger", "Кинжал", "simple", "melee", 2, "1d4", "19–20/×2", 10, 1, "P or S"),
  weapon("punching-dagger", "Punching dagger", "Катар", "simple", "melee", 2, "1d4", "×3", null, 1, "P"),
  weapon("spiked-gauntlet", "Spiked gauntlet", "Шипованная латная перчатка", "simple", "melee", 5, "1d4", "×2", null, 1, "P"),
  weapon("light-mace", "Light mace", "Лёгкая булава", "simple", "melee", 5, "1d6", "×2", null, 4, "B"),
  weapon("sickle", "Sickle", "Серп", "simple", "melee", 6, "1d6", "×2", null, 2, "S", "trip"),
  weapon("club", "Club", "Дубинка", "simple", "melee", 0, "1d6", "×2", 10, 3, "B"),
  weapon("heavy-mace", "Heavy mace", "Тяжёлая булава", "simple", "melee", 12, "1d8", "×2", null, 8, "B"),
  weapon("morningstar", "Morningstar", "Моргенштерн", "simple", "melee", 8, "1d8", "×2", null, 6, "B and P"),
  weapon("shortspear", "Shortspear", "Короткое копьё", "simple", "melee", 1, "1d6", "×2", 20, 3, "P"),
  weapon("longspear", "Longspear", "Длинное копьё", "simple", "melee", 5, "1d8", "×3", null, 9, "P", "brace, reach"),
  weapon("quarterstaff", "Quarterstaff", "Боевой посох", "simple", "melee", 0, "1d6/1d6", "×2", null, 4, "B", "double, monk"),
  weapon("spear", "Spear", "Копьё", "simple", "melee", 2, "1d8", "×3", 20, 6, "P", "brace"),
  weapon("blowgun", "Blowgun", "Духовая трубка", "simple", "ranged", 2, "1d2", "×2", 20, 1, "P"),
  weapon("heavy-crossbow", "Heavy crossbow", "Тяжёлый арбалет", "simple", "ranged", 50, "1d10", "19–20/×2", 120, 8, "P"),
  weapon("light-crossbow", "Light crossbow", "Лёгкий арбалет", "simple", "ranged", 35, "1d8", "19–20/×2", 80, 4, "P"),
  weapon("dart", "Dart", "Дротик", "simple", "ranged", 0.5, "1d4", "×2", 20, 0.5, "P"),
  weapon("javelin", "Javelin", "Метательное копьё", "simple", "ranged", 1, "1d6", "×2", 30, 2, "P"),
  weapon("sling", "Sling", "Праща", "simple", "ranged", 0, "1d4", "×2", 50, 0, "B"),
  weapon("throwing-axe", "Throwing axe", "Метательный топор", "martial", "melee", 8, "1d6", "×2", 10, 2, "S"),
  weapon("light-hammer", "Light hammer", "Лёгкий молот", "martial", "melee", 1, "1d4", "×2", 20, 2, "B"),
  weapon("handaxe", "Handaxe", "Ручной топор", "martial", "melee", 6, "1d6", "×3", null, 3, "S"),
  weapon("kukri", "Kukri", "Кукри", "martial", "melee", 8, "1d4", "18–20/×2", null, 2, "S"),
  weapon("light-pick", "Light pick", "Лёгкий кирочный молот", "martial", "melee", 4, "1d4", "×4", null, 3, "P"),
  weapon("sap", "Sap", "Кистень", "martial", "melee", 1, "1d6", "×2", null, 2, "B", "nonlethal"),
  weapon("light-shield-weapon", "Light shield (weapon)", "Лёгкий щит (оружие)", "martial", "melee", 0, "1d3", "×2", null, null, "B"),
  weapon("spiked-armor", "Spiked armor", "Шипованная броня", "martial", "melee", 50, "1d6", "×2", null, 10, "P"),
  weapon("light-spiked-shield", "Light spiked shield", "Лёгкий шипованный щит", "martial", "melee", 10, "1d4", "×2", null, 5, "P"),
  weapon("starknife", "Starknife", "Звёздный нож", "martial", "melee", 24, "1d4", "×3", 20, 3, "P"),
  weapon("short-sword", "Short sword", "Короткий меч", "martial", "melee", 10, "1d6", "19–20/×2", null, 2, "P"),
  weapon("battleaxe", "Battleaxe", "Боевой топор", "martial", "melee", 10, "1d8", "×3", null, 6, "S"),
  weapon("flail", "Flail", "Цеп", "martial", "melee", 8, "1d8", "×2", null, 5, "B", "disarm, trip"),
  weapon("longsword", "Longsword", "Длинный меч", "martial", "melee", 15, "1d8", "19–20/×2", null, 4, "S"),
  weapon("heavy-pick", "Heavy pick", "Тяжёлый кирочный молот", "martial", "melee", 8, "1d6", "×4", null, 6, "P"),
  weapon("rapier", "Rapier", "Рапира", "martial", "melee", 20, "1d6", "18–20/×2", null, 2, "P"),
  weapon("scimitar", "Scimitar", "Скимитар", "martial", "melee", 15, "1d6", "18–20/×2", null, 4, "S"),
  weapon("heavy-shield-weapon", "Heavy shield (weapon)", "Тяжёлый щит (оружие)", "martial", "melee", 0, "1d4", "×2", null, null, "B"),
  weapon("heavy-spiked-shield", "Heavy spiked shield", "Тяжёлый шипованный щит", "martial", "melee", 10, "1d6", "×2", null, 5, "P"),
  weapon("trident", "Trident", "Трезубец", "martial", "melee", 15, "1d8", "×2", 10, 4, "P", "brace"),
  weapon("warhammer", "Warhammer", "Боевой молот", "martial", "melee", 12, "1d8", "×3", null, 5, "B"),
  weapon("falchion", "Falchion", "Фальшион", "martial", "melee", 75, "2d4", "18–20/×2", null, 8, "S"),
  weapon("glaive", "Glaive", "Глефа", "martial", "melee", 8, "1d10", "×3", null, 10, "S", "reach"),
  weapon("greataxe", "Greataxe", "Секира", "martial", "melee", 20, "1d12", "×3", null, 12, "S"),
  weapon("greatclub", "Greatclub", "Большая дубина", "martial", "melee", 5, "1d10", "×2", null, 8, "B"),
  weapon("heavy-flail", "Heavy flail", "Тяжёлый цеп", "martial", "melee", 15, "1d10", "19–20/×2", null, 10, "B", "disarm, trip"),
  weapon("greatsword", "Greatsword", "Двуручный меч", "martial", "melee", 50, "2d6", "19–20/×2", null, 8, "S"),
  weapon("guisarme", "Guisarme", "Гвизарма", "martial", "melee", 9, "2d4", "×3", null, 12, "S", "reach, trip"),
  weapon("halberd", "Halberd", "Алебарда", "martial", "melee", 10, "1d10", "×3", null, 12, "P or S", "brace, trip"),
  weapon("lance", "Lance", "Рыцарское копьё", "martial", "melee", 10, "1d8", "×3", null, 10, "P", "reach"),
  weapon("ranseur", "Ranseur", "Рунка", "martial", "melee", 10, "2d4", "×3", null, 12, "P", "disarm, reach"),
  weapon("scythe", "Scythe", "Коса", "martial", "melee", 18, "2d4", "×4", null, 10, "P or S", "trip"),
  weapon("longbow", "Longbow", "Длинный лук", "martial", "ranged", 75, "1d8", "×3", 100, 3, "P"),
  weapon("composite-longbow", "Composite longbow", "Композитный длинный лук", "martial", "ranged", 100, "1d8", "×3", 110, 3, "P"),
  weapon("shortbow", "Shortbow", "Короткий лук", "martial", "ranged", 30, "1d6", "×3", 60, 2, "P"),
  weapon("composite-shortbow", "Composite shortbow", "Композитный короткий лук", "martial", "ranged", 75, "1d6", "×3", 70, 2, "P"),
  weapon("kama", "Kama", "Кама", "exotic", "melee", 2, "1d6", "×2", null, 2, "S", "monk, trip"),
  weapon("nunchaku", "Nunchaku", "Нунчаки", "exotic", "melee", 2, "1d6", "×2", null, 2, "B", "disarm, monk"),
  weapon("sai", "Sai", "Сай", "exotic", "melee", 1, "1d4", "×2", null, 1, "B", "disarm, monk"),
  weapon("siangham", "Siangham", "Сянгам", "exotic", "melee", 3, "1d6", "×2", null, 1, "P", "monk"),
  weapon("bastard-sword", "Bastard sword", "Полуторный меч", "exotic", "melee", 35, "1d10", "19–20/×2", null, 6, "S"),
  weapon("dwarven-waraxe", "Dwarven waraxe", "Дварфийский боевой топор", "exotic", "melee", 30, "1d10", "×3", null, 8, "S"),
  weapon("whip", "Whip", "Кнут", "exotic", "melee", 1, "1d3", "×2", null, 2, "S", "disarm, nonlethal, reach, trip"),
  weapon("orc-double-axe", "Orc double axe", "Орочий двойной топор", "exotic", "melee", 60, "1d8/1d8", "×3", null, 15, "S", "double"),
  weapon("spiked-chain", "Spiked chain", "Шипованная цепь", "exotic", "melee", 25, "2d4", "×2", null, 10, "P", "disarm, trip"),
  weapon("elven-curve-blade", "Elven curve blade", "Эльфийский кривой клинок", "exotic", "melee", 80, "1d10", "18–20/×2", null, 7, "S"),
  weapon("dire-flail", "Dire flail", "Двойной цеп", "exotic", "melee", 90, "1d8/1d8", "×2", null, 10, "B", "disarm, double, trip"),
  weapon("gnome-hooked-hammer", "Gnome hooked hammer", "Гномий молот-крюк", "exotic", "melee", 20, "1d8/1d6", "×3/×4", null, 6, "B or P", "double, trip"),
  weapon("two-bladed-sword", "Two-bladed sword", "Двухклинковый меч", "exotic", "melee", 100, "1d8/1d8", "19–20/×2", null, 10, "S", "double"),
  weapon("dwarven-urgrosh", "Dwarven urgrosh", "Дварфийский ургрош", "exotic", "melee", 50, "1d8/1d6", "×3", null, 12, "P or S", "brace, double"),
  weapon("bolas", "Bolas", "Бола", "exotic", "ranged", 5, "1d4", "×2", 10, 2, "B", "nonlethal, trip"),
  weapon("hand-crossbow", "Hand crossbow", "Ручной арбалет", "exotic", "ranged", 100, "1d4", "19–20/×2", 30, 2, "P"),
  weapon("repeating-heavy-crossbow", "Repeating heavy crossbow", "Тяжёлый многозарядный арбалет", "exotic", "ranged", 400, "1d10", "19–20/×2", 120, 12, "P"),
  weapon("repeating-light-crossbow", "Repeating light crossbow", "Лёгкий многозарядный арбалет", "exotic", "ranged", 250, "1d8", "19–20/×2", 80, 6, "P"),
  weapon("net", "Net", "Сеть", "exotic", "ranged", 20, "", "", 10, 6, ""),
  weapon("shuriken", "Shuriken (5)", "Сюрикены (5)", "exotic", "ranged", 1, "1d2", "×2", 10, 0.5, "P", "monk"),
  weapon("halfling-sling-staff", "Halfling sling staff", "Полуросличья посох-праща", "exotic", "ranged", 20, "1d8", "×3", 80, 3, "B"),
];

const AMMUNITION = [
  ammunition("blowgun-darts-10", "Blowgun darts (10)", "Дротики для духовой трубки (10)", 0.5, 0, 10),
  ammunition("crossbow-bolts-10", "Crossbow bolts (10)", "Арбалетные болты (10)", 1, 1, 10),
  ammunition("repeating-crossbow-bolts-5", "Repeating crossbow bolts (5)", "Болты для многозарядного арбалета (5)", 1, 1, 5),
  ammunition("arrows-20", "Arrows (20)", "Стрелы (20)", 1, 3, 20),
  ammunition("sling-bullets-10", "Sling bullets (10)", "Пули для пращи (10)", 0.1, 5, 10),
];

const ARMOR = [
  armor("padded-armor", "Padded armor", "Стёганый доспех", "light", 5, 10, 1),
  armor("leather-armor", "Leather armor", "Кожаный доспех", "light", 10, 15, 2),
  armor("studded-leather", "Studded leather", "Клёпаный кожаный доспех", "light", 25, 20, 3),
  armor("chain-shirt", "Chain shirt", "Кольчужная рубаха", "light", 100, 25, 4),
  armor("hide-armor", "Hide armor", "Шкурный доспех", "medium", 15, 25, 4),
  armor("scale-mail", "Scale mail", "Чешуйчатый доспех", "medium", 50, 30, 5),
  armor("chainmail", "Chainmail", "Кольчуга", "medium", 150, 40, 6),
  armor("breastplate", "Breastplate", "Кираса", "medium", 200, 30, 6),
  armor("splint-mail", "Splint mail", "Шинный доспех", "heavy", 200, 45, 7),
  armor("banded-mail", "Banded mail", "Полосный доспех", "heavy", 250, 35, 7),
  armor("half-plate", "Half-plate", "Полулаты", "heavy", 600, 50, 8),
  armor("full-plate", "Full plate", "Полный латный доспех", "heavy", 1500, 50, 9),
  armor("buckler", "Buckler", "Баклер", "shield", 5, 5, 1),
  armor("light-wooden-shield", "Light wooden shield", "Лёгкий деревянный щит", "shield", 3, 5, 1),
  armor("light-steel-shield", "Light steel shield", "Лёгкий стальной щит", "shield", 9, 6, 1),
  armor("heavy-wooden-shield", "Heavy wooden shield", "Тяжёлый деревянный щит", "shield", 7, 10, 2),
  armor("heavy-steel-shield", "Heavy steel shield", "Тяжёлый стальной щит", "shield", 20, 15, 2),
  armor("tower-shield", "Tower shield", "Башенный щит", "shield", 30, 45, 4),
];

const GEAR_ROWS = [
  ["backpack", "Backpack (empty)", "Рюкзак (пустой)", "gear", 2, 2],
  ["barrel", "Barrel (empty)", "Бочка (пустая)", "gear", 2, 30],
  ["basket", "Basket (empty)", "Корзина (пустая)", "gear", 0.4, 1],
  ["bedroll", "Bedroll", "Спальный мешок", "gear", 0.1, 5],
  ["bell", "Bell", "Колокольчик", "gear", 1, 0],
  ["winter-blanket", "Winter blanket", "Зимнее одеяло", "gear", 0.5, 3],
  ["block-and-tackle", "Block and tackle", "Блок и лебёдка", "gear", 5, 5],
  ["glass-bottle", "Glass bottle", "Стеклянная бутылка", "gear", 2, 1],
  ["bucket", "Bucket (empty)", "Ведро (пустое)", "gear", 0.5, 2],
  ["caltrops", "Caltrops", "Калтропы", "gear", 1, 2],
  ["candle", "Candle", "Свеча", "gear", 0.01, 0],
  ["canvas", "Canvas (sq. yd.)", "Парусина (кв. ярд)", "gear", 0.1, 1],
  ["map-case", "Map or scroll case", "Футляр для карты или свитка", "gear", 1, 0.5],
  ["chain-10-ft", "Chain (10 ft.)", "Цепь (10 футов)", "gear", 30, 2],
  ["chalk", "Chalk (1 piece)", "Мел (1 кусок)", "gear", 0.01, 0],
  ["chest", "Chest (empty)", "Сундук (пустой)", "gear", 2, 25],
  ["crowbar", "Crowbar", "Лом", "gear", 2, 5],
  ["firewood", "Firewood (per day)", "Дрова (на день)", "gear", 0.01, 20],
  ["fishhook", "Fishhook", "Рыболовный крючок", "gear", 0.1, 0],
  ["fishing-net", "Fishing net (25 sq. ft.)", "Рыболовная сеть (25 кв. футов)", "gear", 4, 5],
  ["flask", "Flask (empty)", "Фляга (пустая)", "gear", 0.03, 1.5],
  ["flint-and-steel", "Flint and steel", "Огниво", "gear", 1, 0],
  ["grappling-hook", "Grappling hook", "Крюк-кошка", "gear", 1, 4],
  ["hammer", "Hammer", "Молоток", "gear", 0.5, 2],
  ["hourglass", "Hourglass", "Песочные часы", "gear", 25, 1],
  ["ink", "Ink (1 oz. vial)", "Чернила (флакон 1 унция)", "gear", 8, 0],
  ["inkpen", "Inkpen", "Перо", "gear", 0.1, 0],
  ["clay-jug", "Clay jug", "Глиняный кувшин", "gear", 0.03, 9],
  ["ladder", "Ladder (10 ft.)", "Лестница (10 футов)", "gear", 0.2, 20],
  ["common-lamp", "Common lamp", "Обычная лампа", "gear", 0.1, 1],
  ["bullseye-lantern", "Bullseye lantern", "Направленный фонарь", "gear", 12, 3],
  ["hooded-lantern", "Hooded lantern", "Закрытый фонарь", "gear", 7, 2],
  ["simple-lock", "Simple lock", "Простой замок", "gear", 20, 1],
  ["average-lock", "Average lock", "Обычный замок", "gear", 40, 1],
  ["good-lock", "Good lock", "Хороший замок", "gear", 80, 1],
  ["superior-lock", "Superior lock", "Превосходный замок", "gear", 150, 1],
  ["manacles", "Manacles", "Кандалы", "gear", 15, 2],
  ["small-steel-mirror", "Small steel mirror", "Маленькое стальное зеркало", "gear", 10, 0.5],
  ["clay-mug", "Clay mug/tankard", "Глиняная кружка", "gear", 0.02, 1],
  ["lamp-oil", "Oil (1-pint flask)", "Масло (фляга 1 пинта)", "gear", 0.1, 1],
  ["paper", "Paper (sheet)", "Бумага (лист)", "gear", 0.4, 0],
  ["parchment", "Parchment (sheet)", "Пергамент (лист)", "gear", 0.2, 0],
  ["miners-pick", "Miner's pick", "Кирка рудокопа", "gear", 3, 10],
  ["clay-pitcher", "Clay pitcher", "Глиняный кувшинчик", "gear", 0.02, 5],
  ["piton", "Piton", "Костыль", "gear", 0.1, 0.5],
  ["ten-foot-pole", "10-foot pole", "Шест (10 футов)", "gear", 0.05, 8],
  ["iron-pot", "Iron pot", "Железный котелок", "gear", 0.8, 4],
  ["belt-pouch", "Belt pouch (empty)", "Поясной кошель (пустой)", "gear", 1, 0.5],
  ["portable-ram", "Portable ram", "Переносной таран", "gear", 10, 20],
  ["hemp-rope", "Hemp rope (50 ft.)", "Пеньковая верёвка (50 футов)", "gear", 1, 10],
  ["silk-rope", "Silk rope (50 ft.)", "Шёлковая верёвка (50 футов)", "gear", 10, 5],
  ["sack", "Sack (empty)", "Мешок (пустой)", "gear", 0.1, 0.5],
  ["sealing-wax", "Sealing wax", "Сургуч", "gear", 1, 1],
  ["sewing-needle", "Sewing needle", "Швейная игла", "gear", 0.5, 0],
  ["shovel", "Shovel or spade", "Лопата", "gear", 2, 8],
  ["signal-whistle", "Signal whistle", "Сигнальный свисток", "gear", 0.8, 0],
  ["signet-ring", "Signet ring", "Перстень-печатка", "gear", 5, 0],
  ["sledge", "Sledge", "Кувалда", "gear", 1, 10],
  ["soap", "Soap (per lb.)", "Мыло (1 фунт)", "gear", 0.5, 1],
  ["spyglass", "Spyglass", "Подзорная труба", "gear", 1000, 1],
  ["tent", "Tent", "Палатка", "gear", 10, 20],
  ["torch", "Torch", "Факел", "gear", 0.01, 1],
  ["vial", "Ink or potion vial", "Флакон для чернил или зелья", "gear", 1, 0],
  ["water-clock", "Water clock", "Водяные часы", "gear", 1000, 200],
  ["waterskin", "Waterskin", "Бурдюк", "gear", 1, 4],
  ["whetstone", "Whetstone", "Точильный камень", "gear", 0.02, 1],
  ["alchemists-lab", "Alchemist's lab", "Алхимическая лаборатория", "tool", 200, 40],
  ["artisans-tools", "Artisan's tools", "Ремесленные инструменты", "tool", 5, 5],
  ["climbers-kit", "Climber's kit", "Набор верхолаза", "tool", 80, 5],
  ["disguise-kit", "Disguise kit", "Набор для грима", "tool", 50, 8],
  ["healers-kit", "Healer's kit", "Набор лекаря", "tool", 50, 1],
  ["holly-and-mistletoe", "Holly and mistletoe", "Остролист и омела", "tool", 0, 0],
  ["wooden-holy-symbol", "Wooden holy symbol", "Деревянный священный символ", "tool", 1, 0],
  ["silver-holy-symbol", "Silver holy symbol", "Серебряный священный символ", "tool", 25, 1],
  ["magnifying-glass", "Magnifying glass", "Увеличительное стекло", "tool", 100, 0],
  ["common-instrument", "Common musical instrument", "Обычный музыкальный инструмент", "tool", 5, 3],
  ["merchants-scale", "Merchant's scale", "Купеческие весы", "tool", 2, 1],
  ["spell-component-pouch", "Spell component pouch", "Сумка с материальными компонентами", "tool", 5, 2],
  ["blank-spellbook", "Wizard's spellbook (blank)", "Книга заклинаний волшебника (пустая)", "tool", 15, 3],
  ["thieves-tools", "Thieves' tools", "Воровские инструменты", "tool", 30, 1],
  ["artisans-outfit", "Artisan's outfit", "Одежда ремесленника", "gear", 1, 4],
  ["clerics-vestments", "Cleric's vestments", "Облачение жреца", "gear", 5, 6],
  ["cold-weather-outfit", "Cold-weather outfit", "Одежда для холодной погоды", "gear", 8, 7],
  ["courtiers-outfit", "Courtier's outfit", "Придворный наряд", "gear", 30, 6],
  ["entertainers-outfit", "Entertainer's outfit", "Костюм артиста", "gear", 3, 4],
  ["explorers-outfit", "Explorer's outfit", "Одежда путешественника", "gear", 10, 8],
  ["monks-outfit", "Monk's outfit", "Одежда монаха", "gear", 5, 2],
  ["nobles-outfit", "Noble's outfit", "Дворянский наряд", "gear", 75, 10],
  ["peasants-outfit", "Peasant's outfit", "Крестьянская одежда", "gear", 0.1, 2],
  ["royal-outfit", "Royal outfit", "Королевский наряд", "gear", 200, 15],
  ["scholars-outfit", "Scholar's outfit", "Одежда учёного", "gear", 5, 6],
  ["travelers-outfit", "Traveler's outfit", "Дорожная одежда", "gear", 1, 5],
  ["trail-rations", "Trail rations (per day)", "Сухой паёк (на день)", "food", 0.5, 1],
  ["ale-gallon", "Ale (gallon)", "Эль (галлон)", "food", 0.2, 8],
  ["ale-mug", "Ale (mug)", "Эль (кружка)", "food", 0.04, 1],
  ["bread", "Bread (loaf)", "Хлеб (буханка)", "food", 0.02, 0.5],
  ["cheese", "Cheese (hunk)", "Сыр (кусок)", "food", 0.1, 0.5],
  ["meat", "Meat (chunk)", "Мясо (кусок)", "food", 0.3, 0.5],
  ["common-wine", "Common wine (pitcher)", "Обычное вино (кувшин)", "food", 0.2, 6],
  ["fine-wine", "Fine wine (bottle)", "Изысканное вино (бутылка)", "food", 10, 1.5],
  ["acid", "Acid (flask)", "Кислота (фляга)", "alchemical", 10, 1],
  ["alchemists-fire", "Alchemist's fire (flask)", "Алхимический огонь (фляга)", "alchemical", 20, 1],
  ["antitoxin", "Antitoxin (vial)", "Антитоксин (флакон)", "alchemical", 50, 0],
  ["holy-water", "Holy water (flask)", "Святая вода (фляга)", "alchemical", 25, 1],
  ["smokestick", "Smokestick", "Дымовая шашка", "alchemical", 20, 0.5],
  ["sunrod", "Sunrod", "Солнечный жезл", "alchemical", 2, 1],
  ["tanglefoot-bag", "Tanglefoot bag", "Сумка с липучкой", "alchemical", 50, 4],
  ["thunderstone", "Thunderstone", "Громовой камень", "alchemical", 30, 1],
  ["tindertwig", "Tindertwig", "Спичка", "alchemical", 1, 0],
];

const GOODS = GEAR_ROWS.map(([id, en, ru, category, priceGp, weightLb]) =>
  gear(id, en, ru, category, priceGp, weightLb)
);

export const CORE_INVENTORY_ITEMS = [
  ...WEAPONS,
  ...AMMUNITION,
  ...ARMOR,
  ...GOODS,
];

export const INVENTORY_CATALOG_CATEGORIES = [
  "weapon",
  "ammunition",
  "armor",
  "gear",
  "tool",
  "food",
  "alchemical",
];

export const localizeCatalogName = (item, language) =>
  language === "en" ? item.name.en : item.name.ru;

export const getCatalogSourceUrl = (item, language = "en") => {
  return language === "en"
    ? getEnglishReferenceUrl(item)
    : getPathfinderFamilyUrl(item);
};

export const findInventoryCatalogItem = (catalogId) =>
  CORE_INVENTORY_ITEMS.find((item) => item.id === catalogId);

export const getLocalizedInventoryItemName = (item, language = "en") => {
  const catalogItem = item?.catalogId
    ? findInventoryCatalogItem(item.catalogId)
    : undefined;
  return catalogItem
    ? localizeCatalogName(catalogItem, language)
    : item?.name || "";
};

export const createInventoryItemFromCatalog = (item, language = "en") => {
  const notes = [];
  if (item.critical) notes.push(`Critical: ${item.critical}`);
  if (item.special) notes.push(`Special: ${item.special}`);
  if (item.proficiency) notes.push(`Proficiency: ${item.proficiency}`);
  const storedWeightLb = item.packSize
    ? item.weightLb / item.packSize
    : item.weightLb;

  return {
    catalogId: item.id,
    name: localizeCatalogName(item, language),
    type: item.type,
    amount: item.packSize || 1,
    weight: poundsToKilograms(storedWeightLb, item.packSize ? 4 : 2),
    price: item.priceGp,
    notes: notes.join("; "),
    sourceUrl: getCatalogSourceUrl(item, language),
    weaponType: item.weaponType || "melee",
    range: item.rangeFt ? `${item.rangeFt} ft.` : "",
    damage: item.damage || "",
    crit: calculateCriticalDamage(item.damage, item.critical),
    damageType: item.damageType || "",
    armorType: item.armorType || "armor",
    armorClass: item.armorClass || 0,
  };
};

export { poundsToKilograms };
